import { AlertBanner } from "@similarweb/ui-components";

type ModalErrorBannerProps = {
    message: string;
    dataAutomation?: string;
};

export const ModalErrorBanner = ({ message, dataAutomation = "modal-error-banner" }: ModalErrorBannerProps) => (
    <AlertBanner
        variant="error"
        data-automation={dataAutomation}
    >
        <AlertBanner.Description>{message}</AlertBanner.Description>
    </AlertBanner>
);
